export const buildNumber = '20260925.2';
export const version = 'main';
export const latestCommit = '87d3a0c4465f2d866ce65e14e72b1c3828a70e3c';
